import {
    request,
    requestMedia,
    requestPost,
    requestMedia2
}
    from './request';
export default {
    updateById(data) {
        return request('/api/history/updateUseSendById', data);
    },
    list(data) {
        return request('/api/history/list', data);
    },
    download(data) {
        return requestMedia2('/api/history/download?startDate='+data[0]+'&endDate='+data[1], data);
    },
}


// WEBPACK FOOTER //
// ./src/libs/axios/chatHistory.js